// extracted by mini-css-extract-plugin
export default {"container":"MultiSelect_container__h+i8y","item":"MultiSelect_item__E96cv","orphan":"MultiSelect_orphan__my4VU","empty":"MultiSelect_empty__wbcHp"};